import type { ConditionType, HeliosConditionsBaseState, HeliosConditionsState } from '..';

export const dynamicallyUpdateBase = (
  state: HeliosConditionsState,
  {
    payload,
  }: {
    payload: {
      type: ConditionType;
      key: keyof HeliosConditionsBaseState;
      value: HeliosConditionsBaseState[keyof HeliosConditionsBaseState];
    };
  }
) => {
  state[payload.type] = {
    ...state[payload.type],
    [payload.key]: payload.value,
  } as HeliosConditionsBaseState;
};
